import { StreamActions } from '@hotwired/turbo';

StreamActions.animate_remove = function () {
  this.targetElements.forEach((e) => {
    // Disable interactions during fade out
    e.style.pointerEvents = 'none';

    // Set up the fade out transition
    e.classList.add('!bg-danger-light');
    e.style.transition = 'opacity 600ms ease-out';
    e.style.opacity = '0';

    // Remove element after transition completes
    const handleTransitionEnd = () => {
      e.remove();
    };

    e.addEventListener('transitionend', handleTransitionEnd, { once: true });
  });
};
